// src/utils/clipAssy.ts
//
// FS-637: the twelve Clip assembly variants ("Assy") from the V-1 Production
// assembly drawing, in drawing order. device-data-api keeps the matching list
// and rejects anything else on PUT /devices/:id, so a new variant is a change
// to both lists. The Edit Device modal offers exactly these — no free text.

export const CLIP_ASSY_VARIANTS = [
  'MF75',
  'MF175',
  'MF375',
  'MF400',
  'MF400A',
  'MF437',
  'MF475',
  'MF487',
  'MF500',
  'MF525',
  'MF600',
  'MF600A',
] as const;

export type ClipAssy = (typeof CLIP_ASSY_VARIANTS)[number];
